module.exports = {
	"articleTitle1": "The CCRB is out of shape",
	"catImage": "orangestar.png",
	"totalCats": 2,
	"name": "North Campus Recreational Building (NCRB)",
	"articleLink1": "https://www.michigandaily.com/content/2009-04-15/ccrb-out-shape",
	"articleLink2": "https://www.michigandaily.com/news/contractor-leads-town-hall-pending-ncrb-renovations",
	"articleSnippet1": "Apr 14, 2009 ... The task force most strongly advocated changes to the CCRB, the North Campus \nRecreational Building (NCRB) and the Intramural Sports ...",
	"articleSnippet2": "Mar 24, 2015 ... William Lynch/Daily Members of the North Campus community attend a ... Big \nchanges are ahead for the North Campus Recreation Building.",
	"totalMisc": 0,
	"articleTitle2": "Architecture firm joins forum on NCRB project",
	"address": "2375 Hubbard Rd. Ann Arbor, MI",
	"images": [],
	"position": {
		"lat": 42.295542,
		"lng": -83.720196
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"pickupsports": 1,
		"fitnesscenter": 1,
		"location": 1,
		"recarea": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ncrb.json
// module id = 930
// module chunks = 0